export enum ContentType {
  Book = "book",
  BookEditionChapter = "bookeditionchapter",
}
